var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',[(!_vm.isSpinnerHidden)?_c('div',{class:'uk-height-small uk-flex uk-flex-center uk-flex-middle' + (_vm.isDark ? '' : ' spinner'),attrs:{"uk-spinner":""}}):_vm._e()]):_c('div',{class:_vm.isAnimationDisabled? '' : 'uk-animation-fade'},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }